import {METHOD} from "./method";

export const API_TAX_PLANNING_SETTING = {
    EMPLOYEE_LIST: {
        api: '/v1/hr-adm/payroll/tax-planning',
        method: METHOD.GET
    },
    BULK_UPDATE_STATUS: {
        api: '/v1/hr-adm/payroll/tax-planning/bulk-update',
        method: METHOD.POST
    },
}